import React from "react";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[var(--av-border)] bg-[rgba(0,0,0,0.5)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="font-serif tracking-[0.15em] gold-text font-bold text-lg mb-3">ARTHUR'S VAULT</div>
          <p className="text-sm text-[var(--av-text-dim)]">Premium Apex top-ups for Age of Empires Mobile. Independent marketplace. Not affiliated with Microsoft or Age of Empires.</p>
        </div>
        <div>
          <div className="mono-caption mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-[var(--av-text-dim)]">
            <li><Link to="/store" className="hover:text-[var(--av-gold)]">Apex Store</Link></li>
            <li><Link to="/reviews" className="hover:text-[var(--av-gold)]">Reviews</Link></li>
          </ul>
        </div>
        <div>
          <div className="mono-caption mb-3">Legal</div>
          <ul className="space-y-2 text-sm text-[var(--av-text-dim)]">
            <li><Link to="/legal/terms" className="hover:text-[var(--av-gold)]">Terms &amp; Conditions</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-[var(--av-gold)]">Privacy Policy</Link></li>
            <li><Link to="/legal/rewards" className="hover:text-[var(--av-gold)]">Apex Rewards Terms</Link></li>
            <li><Link to="/legal/refund" className="hover:text-[var(--av-gold)]">Refund Policy</Link></li>
          </ul>
        </div>
        <div>
          <div className="mono-caption mb-3">Support</div>
          <p className="text-sm text-[var(--av-text-dim)]">Sign in and open a ticket from your Vault. Or email <a href="mailto:arthursvault00@gmail.com" className="text-[var(--av-gold)]">arthursvault00@gmail.com</a>.</p>
        </div>
      </div>
      <div className="text-center text-xs text-[var(--av-text-muted)] pb-6">© {new Date().getFullYear()} Arthur's Vault — All rights reserved.</div>
    </footer>
  );
}
